import * as React from "react";
import { useLink } from "@grandvisionhq/frk-routing";
import { QueryString } from "@grandvisionhq/utils";
import ClientSessionManager from "../../../../../../../../../components/ClientSessionManager/v3/components/ClientSessionManager/ClientSessionManager.js";
import LayoutContainer from "../../../../../../../../../components/Layout/v3/components/Layout/LayoutContainer.js";
import useClientSideRouter from "../../../../../../../../../hooks/v3/hooks/use-client-side-router.js";
import { AppointmentContextProvider } from "../../../../../../v3/pages/BookAppointment/context/AppointmentContext.js";
import { RoutingContext } from "./context.js";
import { setStoredAffiliateId } from "../../../../../../../../../utils/v3/utils/affiliate-id-storage.js";
import { fromArrayToString } from "../../../../../../../../../utils/v3/utils/from-array-to-string.js";
const RoutingContextProvider = ({
  routeMap,
  initialRoutingState,
  initialAppointmentState,
  children
}) => {
  const { Provider } = RoutingContext;
  const {
    basePath,
    currentRoute: initialRoute,
    queryParams: initialQueryParams
  } = initialRoutingState;
  const [{ goTo }, { queryParams, currentRoute, routerId }] = useClientSideRouter({
    basePath,
    initialRoute,
    initialQueryParams,
    routerId: "book-appointment"
  });
  const { href: signInMyAccountUrl } = useLink({ route: "auth.login" }) || {};
  const goToHandler = React.useCallback(
    (route, queryParams2) => {
      const newQueryParams = {
        ...queryParams2,
        tryInStoreFlow: initialQueryParams.tryInStoreFlow ? "1" : void 0,
        groupId: initialQueryParams.groupId ? initialQueryParams.groupId : void 0
      };
      Object.keys(newQueryParams).forEach(
        (key) => newQueryParams[key] === void 0 ? delete newQueryParams[key] : {}
      );
      goTo(`${basePath}/${route}${QueryString.stringify(newQueryParams)}`);
    },
    [basePath, goTo, initialQueryParams.tryInStoreFlow, initialQueryParams.groupId]
  );
  const value = React.useMemo(
    () => [
      { goTo: goToHandler },
      {
        component: routeMap[currentRoute],
        queryParams,
        currentRoute,
        basePath,
        signInMyAccountUrl,
        routerId
      }
    ],
    [routeMap, goToHandler, currentRoute, basePath, queryParams, signInMyAccountUrl, routerId]
  );
  const RootComponent = routeMap[currentRoute];
  React.useEffect(() => {
    if (initialQueryParams?.affiliateId) {
      setStoredAffiliateId(fromArrayToString(initialQueryParams?.affiliateId));
    }
  }, [initialQueryParams]);
  return /* @__PURE__ */ React.createElement(Provider, { value }, /* @__PURE__ */ React.createElement(AppointmentContextProvider, { initialState: initialAppointmentState }, /* @__PURE__ */ React.createElement(LayoutContainer, null, /* @__PURE__ */ React.createElement(ClientSessionManager, { initialRoute }, /* @__PURE__ */ React.createElement(RootComponent, null), children))));
};
RoutingContextProvider.getServerSideProps = async (apolloClient, currentRoute, routeMap, params, locale) => {
  const isValidRoute = currentRoute in routeMap;
  if (!isValidRoute) {
    throw new Error("UNKNOWN_ERROR");
  }
  const RootComponent = routeMap[currentRoute];
  const initialAppointmentState = await RootComponent.getServerSideProps(
    apolloClient,
    params,
    locale
  );
  return { initialAppointmentState };
};
export {
  RoutingContextProvider
};
//# sourceMappingURL=provider.js.map
